function loadScssFile(canonicalUrl) {
  return dsf.http.get(canonicalUrl.href).then(({ data }) => {
    return {
      contents: data,
      syntax: "scss"
    };
  });
}
function getURL(url) {
  return new URL(url, window.location.origin);
}
export default {
  compile: (scssStr, canonicalize, load) => {
    let pro;
    if (!window.sass) {
      pro = dsf.http.importFiles(dsf.url.getWebPath("$/js/libs/dartSass/sass.min.js"));
    } else {
      pro = Promise.resolve();
    }
    return pro.then(() => window.sass.compileStringAsync(scssStr, {
      importers: [
        {
          canonicalize: (url) => {
            url = canonicalize(url);
            return getURL(url);
          },
          load: load ? load : loadScssFile
        }
      ]
    })).then(result => result.css);
  }
};
